
<layout-index>
  <template
    v-if="!uploadInstance.getSettings().readonly"
    v-slot:uploadContainer
  >
    <file-input
      v-if="!uploadInstance.anyFile()"
      class="upload-box-container single"
      :title="uploadInstance.getConfig().explain"
    >
      <p class="upload-icon icon-select-file"></p>
    </file-input>
  </template>

  <template v-slot:listContainer>
    <selected-file-info
      v-for="sortKey in uploadInstance.getSelectedFileSortMap().size"
      :key="sortKey"
      :selectedFile="uploadInstance.getSelectedFile(sortKey)"
      v-slot="slotProps"
    >
      <layout-info
        class="item-info-container"
        :slotProps="slotProps"
      ></layout-info>
    </selected-file-info>
  </template>
</layout-index>
